import { FeatureFlag } from '@core/const';
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CORE_FEATURE, CoreState, StateWithCore } from '../core-state';

export const getCoreState: MemoizedSelector<StateWithCore, CoreState> = createFeatureSelector<CoreState>(CORE_FEATURE);

export const getFeatureFlagsState: MemoizedSelector<StateWithCore, CoreState['featureFlags']> = createSelector(
  getCoreState,
  (state: CoreState) => state.featureFlags,
);

export const getFeatureFlagsValue = (): MemoizedSelector<StateWithCore, FeatureFlag[]> =>
  createSelector(getFeatureFlagsState, (state: CoreState['featureFlags']) =>
    StateUtils.loaderValueSelector<FeatureFlag[]>(state),
  );

export const getFeatureFlagsLoading = (): MemoizedSelector<StateWithCore, boolean> =>
  createSelector(getFeatureFlagsState, (state: CoreState['featureFlags']) =>
    StateUtils.loaderLoadingSelector<FeatureFlag[]>(state),
  );

export const getFeatureFlagsError = (): MemoizedSelector<StateWithCore, boolean> =>
  createSelector(getFeatureFlagsState, (state: CoreState['featureFlags']) =>
    StateUtils.loaderErrorSelector<FeatureFlag[]>(state),
  );

export const getFeatureFlagsSuccess = (): MemoizedSelector<StateWithCore, boolean> =>
  createSelector(getFeatureFlagsState, (state: CoreState['featureFlags']) =>
    StateUtils.loaderSuccessSelector<FeatureFlag[]>(state),
  );
